interface Props {
  [key: string]: any
}

export default function HexPlayButton(props: Props): React.ReactElement {
  const { pathClassName, gradientStart, gradientStop, colorMatrix, id, innerIconOpacity = 1, ...rest } = props
  const FilterId = id ? String(id).replace(/'/g, '') : Math.random().toString(36)

  return (
    <svg
      style={{ WebkitTransform: 'translate3d(0,0,0)' }} // Fix for Safari bug
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill="none"
      viewBox="0 0 88 86"
    >
      <g filter={`url(#filter0_${FilterId})`}>
        <path
          d="M40 2C42 1 46 1 49 2L77 17C80 19 82 22 82 26V54C82 58 80 61 77 63L49 78C46 79 42 79 40 78L12 63C8 61 6 58 6 54V26C6 22 8 19 12 17L40 2Z"
          fill={`url(#paint0_${FilterId})`}
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M41.224 25.4471L56.07 35.3476C56.706 35.7717 57.2275 36.3508 57.5882 37.0248C57.9489 37.6988 58.1376 38.4514 58.1376 39.2158C58.1376 39.9803 57.9489 40.7329 57.5882 41.4068C57.2275 42.0808 56.706 42.6554 56.07 43.0794L41.224 52.9799C40.5246 53.4465 39.7117 53.7145 38.872 53.7553C38.0323 53.7961 37.1972 53.6081 36.4559 53.2115C35.7146 52.8149 35.0949 52.2245 34.6629 51.5032C34.2309 50.782 34.0028 49.957 34.0029 49.1163V29.32C34.0011 28.4785 34.228 27.6523 34.6594 26.9298C35.0907 26.2072 35.7102 25.6154 36.4518 25.2177C37.1934 24.82 38.0291 24.6312 38.8697 24.6716C39.7102 24.712 40.524 24.9801 41.224 25.4471Z"
        fill="white"
        fillOpacity={innerIconOpacity}
      />
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="83"
          id={`filter0_${FilterId}`}
          width="76"
          x="6"
          y="1"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={colorMatrix} />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1883_103692" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1883_103692" mode="normal" result="shape" />
        </filter>
        <linearGradient gradientUnits="userSpaceOnUse" id={`paint0_${FilterId}`} x1="54" x2="53" y1="80" y2="0">
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} />
        </linearGradient>
      </defs>
    </svg>
  )
}
